<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-row justify="center">
            <v-col cols="12" md="12" lg="8">
                <v-container>
                    <v-form ref="form" lazy-validation>
                        <h2>{{ $t('login.passwordreset-title') }}</h2>
    
                        <h6 color="error" v-if="error" v-html="errorHint"></h6>
    
                        <label>{{ $t('global.form.usernameOrEmail') }}</label>
                        <v-text-field v-model="email"
                            variant="outlined" hide-details="true" density="compact" class="py-0 mb-3" height="32px" :rules="emailRules">
                        </v-text-field>
    
    
                        <v-row justify="between">
                            <v-col justify-content="start" class="text-start">
                                <v-btn @click="$router.back()" variant="flat" size="large" color="default" rounded="xl"
                                    class="white--text mb-2">{{ $t('entity.action.back') }}</v-btn>
                            </v-col>
                            <v-col>
                                <v-btn @click="resetPassword" variant="flat" size="large" color="primary" rounded="xl"
                                    class="white--text mb-2 find-favourites-button float-right">{{ $t('entity.action.next') }}</v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import { ref, getCurrentInstance, inject,useTemplateRef } from "vue";
import { useRouter } from 'vue-router'

export default {
    data() {
        return {
            tab: 'Lieblingsmarken',
        }
    },
    setup() {

        const { proxy } = getCurrentInstance();
        const email = ref(null);
        const router = useRouter();
        const errorHint = ref(null);
        const show1 = ref(true)
        const error = ref(false)
        const form = useTemplateRef('form');

        const emailRules = [
            v => !!v || proxy.$t('login.messages.error.no_value'),
            v => /.+@.+\..+/.test(v) || proxy.$t('login.messages.error.no_value'),
        ];

        const validate = async () => {
            const { valid, errors } = await form.value.validate()
            if (!valid) {
                let errorMessages = [];
                Object.values(errors).forEach(fieldErrors => {
                    if (fieldErrors.errorMessages.length) {
                        errorMessages.push(...fieldErrors.errorMessages);
                    }
                });
                errorMessages.forEach(msg => {
                    if (msg.length) {
                        proxy.$toast.error(msg, { theme: "colored" });
                    }
                })
                // Show errors in toast
                // proxy.$toast.error("HEY I GUESS", { theme: "colored" })
                return false;
            }
            return true;
        }

        const resetPassword = async () => {
            if (!(await validate())) return;
            try {
                const response = await proxy.$axios.post("/public/passwordreset", {
                    username: email.value,
                });
                
                if (response.data.status == "OK") {
                    // successfullyLoggenIn(response.data);
                }else if (response.data.status == "ERROR"){
                    if(response.data.fields.email != null){
                        // error.value = true;
                        // errorHint.value = proxy.$t('login.messages.error.authentication')
                        proxy.$toast.error(proxy.$t('login.messages.error.authentication'), { theme: "colored" });
                    }
                }
            } catch (error) {
                console.error("Error: ", error);
            }
        };

        return {
            show1,
            resetPassword,
            email,
            errorHint,
            error,
            emailRules,
            ref
        };
    },
};
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    width: 900px;
}

.v-tab-selected {
    text-decoration: underline;
}

.v-tab {
    font-size: 26px;
    font-weight: 800;
    font-family: Montserrat, sans-serif;
    letter-spacing: normal;
}

.v-btn.find-favourites-button {
    font-size: 14px;
    font-weight: 400;
}

a {
    text-decoration: none;
    font-size: 14px;
    font-weight: 300;
}

.v-label div {
    display: inline-block;
    max-width: 100%;
    /* margin-bottom: 5px; */
    font-weight: 700;
    font-size: 14px;
}
</style>